export {InputAutocompleteConnected as InputAutocomplete} from './input-autocomplete-connected';
export {InputAutocomplete as InputAutocompleteStandalone} from './input-autocomplete';
export {TagAutocompleteConnected as TagAutocomplete} from './tag-autocomplete-connected';
